import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Popover as OriginalPopover } from 'antd-mobile';
const Popover = (props, ref) => {
    const { children, __designMode, ...innerProps } = props;
    const isDesign = __designMode === 'design';
    const nativePopoverRef = useRef(null);
    const wrapperRef = useRef(null);
    useImperativeHandle(ref, () => {
        if (wrapperRef.current) {
            wrapperRef.current.show = nativePopoverRef.current.show;
            wrapperRef.current.hide = nativePopoverRef.current.hide;
        }
        return wrapperRef.current;
    });
    const additionProps = isDesign ? { defaultVisible: true } : {};
    return (React.createElement("div", { ref: wrapperRef, style: { display: 'inline-block' } },
        React.createElement(OriginalPopover, Object.assign({}, innerProps, additionProps, { ref: nativePopoverRef, trigger: "click" }), Array.isArray(children) ? children[0] : children)));
};
export default forwardRef(Popover);
